<template>
  <div class="body">
    <div class="is-pay">
      <i class="icon icon-time"></i>
      <div>待支付</div>
      <p>剩余{{pay_end_time_txt}}自动取消</p>
    </div>
    <div v-if="shouList.length==0">
      <div class="add-add" @click="goAddress">
        <i class="icon icon-add-add"></i>
        新增收货地址
      </div>
      <!--<div class="exps">配送：京东快递、顺丰快递；</div>-->
    </div>

    <div class="shou-box" v-if="shouList.length!=0" @click="goAddList">
      <h3>
        <span>收货人：{{cdefault.zname}}</span>
        <span>{{cdefault.mobile?cdefault.mobile.slice(0,3)+'****'+cdefault.mobile.slice(-4):''}}</span>
      </h3>
      <p>收货地址：{{cdefault.province}} {{cdefault.city}} {{cdefault.area}} {{cdefault.address}}</p>
      <i class="icon icon-enter"></i>
    </div>

    <div class="pres">
      <div class="pres-head">处方</div>
      <div class="pat-cont font-85">
        <div class="pat-item">
          <p>姓名</p>
          <div class="pat-item-detail">{{yaoinfo.orderInfo.patient_name}}</div>
        </div>
        <div class="pat-item">
          <p>性别</p>
          <div class="pat-item-detail">{{yaoinfo.orderInfo.patient_sex == 1?'男':'女'}}</div>
        </div>
        <div class="pat-item">
          <p>年龄</p>
          <div class="pat-item-detail">{{yaoinfo.orderInfo.patient_age}}岁</div>
        </div>
        <div class="pat-item">
          <p>科别</p>
          <div class="pat-item-detail">{{yaoinfo.yaoInfo.department}}</div>
        </div>
      </div>
      <div class="zhenduan">
        <p class="diagnosis"><span style="display:inline-block;width:auto;">诊断：</span>{{yaoinfo.yaoInfo.sike}}</p>
        <p style="position:relative;">
          支付后即可查看处方
          <span class="yao-num" v-if="yaoinfo.yaoInfo.typeid !=3 && yaoinfo.yaoInfo.typeid !=4">共{{yaoinfo.yaoInfo.content.length}}味</span>
          <span class="yao-num" v-else>共{{yaoinfo.yaoInfo.content.length}}种</span>
        </p>
      </div>
      <div class="docname font-85">医师：{{yaoinfo.orderInfo.docname}}</div>
    </div>
    <div class="prices server-box" v-if="yaoinfo.yaoInfo.yaofang_type==1">
      <div class="price-item">
        <span>是否代煎</span>
        <span>
          <label>
             <input name="servers" type="radio" :checked="yaoinfo.yaoInfo.cook == 1" @change="getServermoney(1)">代煎
          </label>
          <label>
             <input name="servers" type="radio" :checked="yaoinfo.yaoInfo.cook == 2" @change="getServermoney(2)">不代煎
          </label>
        </span>
      </div>
    </div>
    <div class="prices">
      <div class="price-item">
        <span>药费</span>
        <span>￥{{(yaoinfo.yaoInfo.yao_money/100).toFixed(2)}}</span>
      </div>
      <div class="price-item" v-if="yaoinfo.yaoInfo.typeid !=3 && yaoinfo.yaoInfo.typeid !=4">
        <span>代煎费</span>
        <span>￥{{(yaoinfo.yaoInfo.servier_money/100).toFixed(2)}}</span>
      </div>
      <div class="price-item">
        <span>运费</span>
        <span>￥{{(yaoinfo.orderInfo.yun_money/100).toFixed(2)}}</span>
      </div>
      <div class="price">
        <span>合计：</span>
        <span class="font-red">￥{{(yaoinfo.orderInfo.charge_amount/100).toFixed(2)}}</span>
      </div>
    </div>
    <div class="mask" v-if="paying"></div>
    <div class="pay-bottom">
      <div class="kefu" @click="handleCall">
        <i class="icon icon-kefu"></i>
        <div class="kefu-txt">客服</div>
      </div>
      <div class="pay-price">实付：{{(yaoinfo.orderInfo.charge_amount/100).toFixed(2)}}元</div>
      <div class="pay-btn" @click="gopay">去支付</div>
    </div>
  </div>
</template>

<script>
import http from "../../request/http";
import { getCustomerPhone } from "../../utils/index";
export default {
  name: "order_pay",
  data() {
    return {
      yaoinfo: {
        orderInfo: {
          patient_name: "",
        },
        yaoInfo: {
          department: "",
          content: [],
        },
      },
      orderid: "",
      cid: "",
      shouList: [],
      cdefault: {},
      pay_end_time: 0,
      pay_end_time_txt: '0时0分',
      timerOut:null,
      paying:false
    };
  },
  mounted() {
    this.orderid = this.$route.query.orderid;
    this.cid = this.$route.query.cid;
    this.getclist();
    if (this.orderid) {
      this.getyaoinfo();
    }
  },
  methods: {
    handleCall() {
      if (this.$cookies.get("customer_phone")) {
        window.location.href = `tel:${this.$cookies.get("customer_phone")}`;
      } else {
        getCustomerPhone(this, (phone) => {
          window.location.href = `tel:${phone}`;
        });
      }
    },
    addZero(i) {
      return i < 10 ? "0" + i : i + "";
    },
    count_down() {
      let nowtime = new Date().getTime();
      let endtime = this.pay_end_time;
      let lefttime = parseInt((endtime - nowtime) / 1000);
      if (lefttime <= 0) {
        if (this.timerOut) {
          clearTimeout(this.timerOut);
          this.timerOut = null;
        }
        return;
      }
      let h = parseInt(lefttime / (60 * 60));
      let m = parseInt((lefttime / 60) % 60);
      h = this.addZero(h);
      m = this.addZero(m);
      this.pay_end_time_txt = `${h}时${m}分`;
      this.timerOut = setTimeout(this.count_down, 1000);
    },
    getyaoinfo() {
      http
        .post("/api/wap/order/yaoinfo", {
          order_id: this.orderid,
        })
        .then((res) => {
          this.pay_end_time =
            res.data.orderInfo.ctime * 1000 + 1000 * 60 * 60 * 24 * 3;
          console.log(this.pay_end_time);
          this.yaoinfo = res.data;
          this.count_down();
          console.log(res);
          this.getServermoney(res.data.yaoInfo.cook);
        });
    },
    goAddress() {
      this.$router.push({
        name: "address_edit",
        query: {
          from: "order_pay",
          orderid: this.orderid,
        },
      });
    },
    goAddList() {
      this.$router.push({
        name: "address_list",
        query: {
          from: "order_pay",
          orderid: this.orderid,
          cid: this.cid,
        },
      });
    },
    getclist() {
      http.post("/api/wap/user/consigneelist").then((res) => {
        console.log('就诊',res)
        this.shouList = res.data;
        if(res.data.length != 0){
          res.data.forEach((e) => {
            if (this.$route.query.cid){
              if(this.$route.query.cid == e.id) {
                this.cdefault = e;
                this.cid = e.id;
              }
            } else{
              if (e.default == 1){
                this.cdefault = e;
                this.cid = e.id;
              }else{
                this.cdefault = this.shouList[0];
                this.cid = this.shouList[0].id;
              }
            }
          });
        }
      });
    },
    getServermoney(cook){
      http.post('/api/wap/order/revisit',{
        order_id:this.orderid,
        cook:cook
      }).then(res=>{
        console.log(res)

        this.yaoinfo.orderInfo.charge_amount = res.data.charge_amount;
        this.yaoinfo.orderInfo.servier_money = res.data.servier_money;
        this.yaoinfo.orderInfo.yao_money = res.data.yao_money;
      })
    },
    gopay(){
      if(this.cid == ''||this.cid == null){
        console.log(this.cid)
        this.$toast.center('请选择收货人')
      }else{

        this.paying = true;
        http.post("/api/wap/order/yaopay", {
            order_id: this.orderid,
            cid: this.cid,
            currency: "cny",
            channel: "wx_pub",
          }).then((res) => {
            if (res.errno == 0) {
              let pingpp = require("pingpp-js");
              pingpp.createPayment(res.data, (result, err) => {
                if (result == "success") {
                  // 只有微信公众账号 (wx_pub)、微信小程序 (wx_lite)、QQ 公众号 (qpay_pub)、支付宝口碑 (alipay_qr)
                  // 支付成功的结果会在这里返回，其他的支付结果都会跳转到 extra 中对应的 URL。
                  this.paying = false;
                  this.$toast.center("支付成功");
                  this.$router.push("/my_shop_car");
                } else if (result == "fail") {
                  // data 不正确或者微信公众账号/微信小程序/QQ 公众号/支付宝口碑支付失败时会在此处返回
                  this.$toast.center("支付异常，请重试");
                  this.paying = false;
                } else if (result == "cancel") {
                  // 微信公众账号、微信小程序、QQ 公众号、支付宝口碑支付取消支付
                  console.log("wx_pub cancel");
                  this.$toast.center("取消支付");
                  this.paying = false;
                }
              });
            }else{
              this.paying = false;
            }
          }).catch(err => {
            console.log(err)
            this.paying = false;
          })
      }
    },
  },
  destroyed() {
    if (this.timerOut) {
      clearTimeout(this.timerOut);
      this.timerOut = null;
    }
  },
};
</script>

<style scoped>
.yao-num{
  position: absolute;
  top:0;
  right: 0;
}
.body {
  padding-top: 0;
}

.icon-time {
  content: url("../../../static/icons/To_be_paid@3x.png");
  width: 1rem;
  height: 1rem;
  margin:0 0.6rem 0 0;
  float: left;
}
.server-box{
  margin: 0.5rem 0;
  height: 2.8rem;
}
.server-box input{
  margin-right: 0.4rem;
}
.server-box label:first-child{
  margin-right: 1.5rem;
}
.is-pay {
  background: url("../../../static/icons/wdbj_bg_red@3x.png") no-repeat;
  padding: 1.3rem 1rem;
  display: flex;
  line-height: 1.4rem;
  justify-content: flex-start;
  align-items: center;
}
.is-pay div {
  height: 1.4rem;
  line-height: 1.4rem;
  font-size: 1rem;
  float: left;
}
.is-pay p {
  font-size: 0.6rem;
  margin-left: 0.6rem;
  height: 1rem;
  line-height: 1rem;
  float: left;
  /* margin-top: 0.4rem; */
}
.add-add {
  border-bottom: 0.05rem solid #f5f5f5;
  margin: 0;
}
.exps {
  width: 100%;
  height: 2.7rem;
  background: #fff;
  padding: 0 1rem;
  line-height: 2.7rem;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.65);
}
.pres {
  width: 100%;
  height: auto;
  background: #feffe6;
}
.pres-head {
  width: 100%;
  height: 2.8rem;
  text-align: center;
  font-size: 1rem;
  line-height: 2.8rem;
  border-bottom: 0.05rem solid #f5f5f5;
  font-weight: 700;
}
.pat-cont {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 2rem;
}
.pat-item {
  text-align: center;
  font-size: 16px;
}
.pat-item p {
  font-size: 0.6rem;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 0.4rem;
}
.zhenduan {
  padding: 0 1rem 1rem;
  border-bottom: 0.05rem solid #f5f5f5;
}
.zhenduan p {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.6rem;
}
.docname {
  line-height: 3.2rem;
  font-size: 0.8rem;
  text-align: right;
  padding: 0 1rem;
}
.prices {
  padding: .8rem 1rem 0 1rem;
  background: #fff;
}
.price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  height: 1.2rem;
  color: rgba(0, 0, 0, 0.65);
  /* line-height: 1.5rem; */
}
.price-item + .price-item{
  margin-top: 0.4rem;
}
.price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.2rem;
  font-size: 0.8rem;
  border-top: 0.05rem solid #f5f5f5;
  margin-top: 1rem;
}
.shou-box {
  background: #fff;
  padding: 1rem;
  padding-right: 2.3rem;
  position: relative;
}
.icon-enter {
  content: url("../../../static/icons/enter@3x.png");
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  top: 50%;
  right: 1rem;
  margin-top: -0.25rem;
}
.shou-box h3 {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.4rem;
}
.shou-box p {
  line-height: 1.1rem;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.65);
}
.pay-bottom{
  display: block;
  padding:0.4rem 1rem;
}
.pay-bottom .pay-price {
  width: calc(100% - 7.75rem);
  text-align: left;
  float: left;
  height: 2rem;
  line-height: 2rem;
}
.pat-item-detail{
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.8rem;
}
.kefu{
  width: auto;
  float: left;
  padding-top: 0.1rem;
}
.pay-btn{
  width: auto;
  float: left;
  padding:0 1.6rem;
}
.kefu-txt{
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.6rem;
  margin-top: 0.1rem;
}
.diagnosis{
  word-break:break-word;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order_pay.vue